var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMicrophoneDisabled = function SvgMicrophoneDisabled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M4.929 16.26 18.01 3.18"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M12 19.233c3.075 0 5.719-1.947 6.876-4.733M12 19.233V21.6m0-2.367c-1.898 0-3.632-.742-4.953-1.965m7.45-13.709a4.25 4.25 0 0 0-6.747 3.44v3.315m8.5-2.14v3.324s0 0 0 0a4.25 4.25 0 0 1-6.755 3.434"
  })));
};
export default SvgMicrophoneDisabled;